import { useQuery } from "react-query";
import { GET_DEVELOPMENTAL_HISTORY, STALE_TIME_5_MINUTES } from "@constants/reactQueryKeys";
import { getDevelopmentalHistory } from "api/customers";

const useGetDevelopmentalHistory = (clientId: number | null) => {
  const { data, isLoading, refetch, ...rest } = useQuery(
    [GET_DEVELOPMENTAL_HISTORY, clientId],
    () => getDevelopmentalHistory(clientId),
    {
      staleTime: STALE_TIME_5_MINUTES,
      enabled: Boolean(clientId),
      refetchOnWindowFocus: false,
    }
  );

  return {
    developmentalHistory: data?.data || null,
    developmentalHistoryLoading: isLoading,
    refetchDevelopmentalHistory: refetch,
    ...rest,
  };
};

export default useGetDevelopmentalHistory;
